import { render, staticRenderFns } from "./NewResume.vue?vue&type=template&id=68c4bf6c&"
import script from "./NewResume.vue?vue&type=script&lang=js&"
export * from "./NewResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports